import { useEffect, useState } from "react";
import { SEX_STORAGE_KEY, WEIGHT_STORAGE_KEY } from "./constants";
import type { Sex } from "./types";
import { readStorage, writeStorage } from "../../../utils/safeStorage";

const storageKey = (key: string, userId: number | null) => userId === null ? key : `${key}:${userId}`;
const loadWeight = (userId: number | null) => {
    if (typeof window === "undefined") return 80;
    const parsed = Number.parseFloat(readStorage(storageKey(WEIGHT_STORAGE_KEY, userId)) ?? "");
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 80;
};

const loadSex = (userId: number | null): Sex => typeof window !== "undefined" && readStorage(storageKey(SEX_STORAGE_KEY, userId)) === "female"
    ? "female" : "male";

export const useMetabolismStorage = (userId: number | null = null) => {
    const [settings, setSettings] = useState(() => ({ userId, weightKg: loadWeight(userId), sex: loadSex(userId) }));
    const current = settings.userId === userId ? settings : { userId, weightKg: loadWeight(userId), sex: loadSex(userId) };

    useEffect(() => {
        setSettings(previous => previous.userId === userId ? previous : { userId, weightKg: loadWeight(userId), sex: loadSex(userId) });
    }, [userId]);
    useEffect(() => {
        if (typeof window !== "undefined") {
            writeStorage(storageKey(WEIGHT_STORAGE_KEY, settings.userId), String(settings.weightKg));
            writeStorage(storageKey(SEX_STORAGE_KEY, settings.userId), settings.sex);
        }
    }, [settings]);

    return {
        weightKg: current.weightKg,
        setWeightKg: (weightKg: number) => setSettings((value) => ({ ...(value.userId === userId ? value : current), weightKg })),
        sex: current.sex,
        setSex: (sex: Sex) => setSettings((value) => ({ ...(value.userId === userId ? value : current), sex })),
    };
};
